import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import _ from 'lodash'
import { compose } from 'redux'
import { connect } from 'react-redux'

import withLanguage from '../lang-select/withLanguage'

const TownHeader = ({ town, language = 'th' }) => (
  <div className="columns" style={{ marginTop: 20 }}>
    <div className="column">
      <h1 className="title">
        {_.get(town, `title.${language}`) || '--'} Town
      </h1>
      {/* <div className="tags">
          <span className="tag">aaa</span>
        </div> */}
    </div>
    <div className="column is-pulled-right">
      <Breadcrumb />
    </div>
  </div>
)

const Breadcrumb = withRouter(({ match }) => {
  return (
    <nav className="breadcrumb is-right" aria-label="breadcrumbs">
      <ul>
        <li
          className={classNames({
            'is-active': _.includes(match.path, 'listings'),
          })}
        >
          <Link to={`/towns/${match.params.townID}/listings`} replace>
            Listing
          </Link>
        </li>
        <li
          className={classNames({
            'is-active': _.includes(match.path, 'banners'),
          })}
        >
          <Link to={`/towns/${match.params.townID}/banners`} replace>
            Banner
          </Link>
        </li>
      </ul>
    </nav>
  )
})

export default compose(
  withLanguage,
  connect(({ town }) => ({ town })),
)(TownHeader)



// WEBPACK FOOTER //
// ./src/components/templates/navbar/TownHeader.js